import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import '../accountTheme.css';
import './ContactUsScreen.css';

const SUPPORT_EMAIL = 'contact11gamez@gmail.com';

function ContactUsScreen({ onBack }) {
  return (
    <Box className="bz-page">
      <Box className="bz-topbar">
        <IconButton size="small" onClick={onBack} className="bz-back-btn">
          <ArrowBackIosNewRoundedIcon fontSize="small" />
        </IconButton>
        <Typography className="bz-topbar__title">Contact Us</Typography>
        <Box sx={{ width: 32 }} />
      </Box>

      <Box className="bz-scroll">
        <Box className="contact-hero">
          <SupportAgentRoundedIcon className="contact-hero__icon" />
          <Typography className="contact-hero__title">Need help?</Typography>
          <Typography className="contact-hero__text">
            If you have any questions about your account, wallet, deposits, withdrawals, or games,
            our support team is here to help.
          </Typography>
        </Box>

        <Typography className="bz-section-title">Get in touch</Typography>
        <Box className="bz-card contact-card">
          <Box className="contact-card__row">
            <EmailOutlinedIcon className="contact-card__icon" />
            <Box>
              <Typography className="contact-card__label">Email support</Typography>
              <Typography className="contact-card__hint">
                For any query, please contact us at the email below.
              </Typography>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="contact-card__email">
                {SUPPORT_EMAIL}
              </a>
            </Box>
          </Box>
        </Box>

        <Typography className="contact-note">
          We aim to respond within 24–48 hours on business days.
        </Typography>
      </Box>
    </Box>
  );
}

export default ContactUsScreen;
